module.exports = __webpack_public_path__ + "img/LINK.eda9cdbf.svg";